const notWhitespace = (str: string): boolean => !/\s/.test(str);

const firstCapitalizedLetter = (str: string): string | undefined =>
    [...str].filter(notWhitespace).find((char) => char === char.toUpperCase());

export const getUserInitials = (originalFirstName: string, originalLastName: string): string => {
    const firstName = originalFirstName.trim();
    const lastName = originalLastName.trim();

    const firstLetterFirstName = firstName.charAt(0).toUpperCase();
    const firstLetterLastName = firstCapitalizedLetter(lastName) ?? lastName.charAt(0).toUpperCase();

    const initials = `${firstLetterFirstName}${firstLetterLastName}`.trim();

    if (/^(ss|sa|hh)$/i.test(initials)) {
        const secondLetterFirstName = firstName.charAt(1).toUpperCase();

        return `${firstLetterFirstName}${secondLetterFirstName}${firstLetterLastName}`.trim();
    }

    return initials;
};
